<template>
	<div id="page">
		<div class="block-wrapper pt-4">
			<div class="content sans lazy-container mb-24">
				<div class="block-wrapper">
					<h3 class="block-heading mb2">
						Support Us
					</h3>
					
					<!-- <div class="block-content flex two-col">
						<div class="block-column col-6">aa</div>
						<div class="block-column col-6">bb</div>
					</div> -->
					<div class="block-content">

						<p>Since 2010, FA has investigated state and corporate violence and human rights violations around the world, publishing over a hundred investigations in support of communities and families struggling for accountability.</p>

						<p>Our work has been active in national and international courtrooms, political inquiries, truth commissions, and citizens’ tribunals. We’ve won awards across the fields of human rights, journalism, architecture, design, technology, and the arts. Our work has been shown in major galleries and museums, we’ve partnered with virtually every major international media outlet, and seen our work taught at universities worldwide.</p>
						
						<p>None of that would be possible without our supporters. We welcome donations from individuals and organisations who share our values, and who wish to support any area of FA’s work.</p>
						
						<p>Your donation will be managed through Goldsmiths, University of London.</p>

					</div>

					<h3 
						class="block-heading mb2 cursor-pointer"
						:class="{ 'toggle--open': toggleStates[0] }"
						@click="onToggle(0)"
					>
						<div class="flex justify-between gap-2 items-center">
							<div>To make a donation of £3,000 or less</div>
							<img 
								:class="{ 'hidden': toggleStates[0] }" 
								class="nolazy w-5 h-5 angle-image" 
								alt="" src="@/assets/angle-down-sharp-light.svg">
							<img 
								:class="{ 'hidden': !toggleStates[0] }" 
								class="nolazy w-5 h-5 angle-image" 
								alt="" src="@/assets/angle-up-sharp-light.svg">
						</div>
					</h3>
					<div class="block-content hidden">

						<p>Please fill out the form below:</p>
						
						<DonationForm
							v-if="showDonationForm"
							env="renxt"
							publicKey="p-SntRsA0XDEuKUQc3i05pcg"
							guid="bf39b9f8-7cdf-41ae-9bbd-78cfaa14064d"
							currency="eur"
						/>
					

					</div>
					<h3 
						class="group block-heading mb2 cursor-pointer toggle"
						:class="{ 'toggle--open': toggleStates[1] }"
						@click="onToggle(1)"
					>
						<div class="flex justify-between gap-2 items-center">
							<div>To make a donation of between £3,001 and £10,000</div>
							<img 
								:class="{ 'hidden': toggleStates[1] }" 
								class="nolazy w-5 h-5 angle-image" 
								alt="" src="@/assets/angle-down-sharp-light.svg">
							<img 
								:class="{ 'hidden': !toggleStates[1] }" 
								class="nolazy w-5 h-5 angle-image" 
								alt="" src="@/assets/angle-up-sharp-light.svg">
						</div>
						
					</h3>

					<div class="block-content hidden">
						<p>You can donate through bank transfer.</p> 

						<p>Please email <a href="mailto:am@forensic-architecture.org">am@forensic-architecture.org</a> to request our bank details. Please provide your name, contact information and donation amount in the email.</p>

						<p><em>For donations from the United States of America:</em></p>

						<p>Please make payment to the British Schools and Universities Foundation, Inc. (BSUF), with instructions to direct the funds to ‘Goldsmiths’ College’. The BSUF donate page is available <a href="https://www.bsuf.org/donate">here</a> ↗</p>

						<p><span style="color: var(--red);">Please use the reference ‘Forensic Architecture’.</span></p>
					</div>
					<h3 
						class="group block-heading mb2 cursor-pointer toggle"
						:class="{ 'toggle--open': toggleStates[2] }"
						@click="onToggle(2)"
					>
						<div class="flex justify-between gap-2 items-center">
							<div>For donations over £10,000</div>
							<img 
								:class="{ 'hidden': toggleStates[2] }" 
								class="nolazy w-5 h-5 angle-image" 
								alt="" src="@/assets/angle-down-sharp-light.svg">
							<img 
								:class="{ 'hidden': !toggleStates[2] }" 
								class="nolazy w-5 h-5 angle-image" 
								alt="" src="@/assets/angle-up-sharp-light.svg">
						</div>
						
					</h3>

					<div class="block-content hidden">

						<p>Please contact Forensic Architecture so we can make arrangements to facilitate your donation.</p>

						<p>Donations to Forensic Architecture are supported by Goldsmiths’ Development and Alumni Office. </p>

						<p>If you have any queries, please contact Forensic Architecture’s Assistant Director of Operations at <a href="mailto:am@forensic-architecture.org">am@forensic-architecture.org</a>.</p>

						<p>Thank you for supporting our research and investigations through your generous donation.</p>

						 
					</div>

				</div>

				
			</div>

			
		</div>
		
	</div>
</template>
<script>
import DonationForm from "@/components/DonationForm.vue";

export default {
	name: "Donate",
	components: { DonationForm },
	data() {
		return {
			toggleStates: [false, false, false],
			showDonationForm: false, // becomes true the first time section 1 opens
		};
	},
	methods: {
		onToggle(index) {
			const opening = !this.toggleStates[index];
			this.$set(this.toggleStates, index, opening);

			// When the first panel opens the first time, mount the form
			if (index === 0 && opening && !this.showDonationForm) {
				this.showDonationForm = true;
			}
		}
	}
}
</script>
<style type="text/css">
	
	.block-wrapper .angle-image {
		margin: 0;
		border: none;
		&:hover {
			border: none;
		}
		&.hidden {
			display: none;
		}
	}
	h3.block-heading.toggle {
		margin-top: 2rem;

	}
	.toggle--open {
	
		+ .block-content {
			display: block;
		}
	}
	@media (--phone) {
		.block-wrapper img {
			margin: 0 !important;
			width: auto;
		}
	}
</style>